/**
 * OAuth flows store the pre-auth location as `window.location.hash`
 * (e.g. "#/crate/123"). With the hash router, history.push/replace expect a
 * route path ("/crate/123"). Passing "#/crate/123" resolves to
 * "#/tidal/callback#/crate/123", leaving the user stuck on the callback page.
 */
const normalizeHashRedirect = (
  redirect: string | null | undefined,
  fallback = '/pipelines',
): string => {
  if (!redirect) return fallback;
  let path = redirect.trim();
  if (path.startsWith('#')) path = path.slice(1);
  if (!path) return fallback;
  if (!path.startsWith('/')) path = `/${path}`;
  return path;
};

export default normalizeHashRedirect;
